import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import tableEN from './translate/table/en/table.json';
import stringEN from './translate/language/en/string_en.json';
import arrayEN from './translate/language/en/array_en.json';
import calcEN from './translate/calc/en/calculators.json';

// periodic_table_1 / periodic_table_2 для каждого языка
const titles = {
  en: ['Periodic', 'Table'],
  de: ['Periodensystem', ''],
  ko: ['주기율표', ''],
  pt_PT: ['Tabela', 'Periódica'],
  pt_BR: ['Tabela', 'Periódica'],
  ru: ['Таблица', 'Менделеева'],
  es: ['Tabla', 'Periódica'],
  hi: ['आवर्त सारणी', ''],
  zh_CN: ['元素周期表', ''],
  zh_TW: ['元素週期表', ''],
  be: ['Табліца', 'Мендзялеева'],
  cs: ['Periodická', 'Tabulka'],
  fil: ['Periodic', 'Table'],
  fr: ['Tableau', 'Périodique'],
  it: ['Tavola', 'Periodica'],
  ja: ['周期表', ' '],
  kk: ['Менделеев', 'Кестесі'],
  pl: ['Układ', 'Okresowy'],
  th: ['Periodic', 'Table'],
  tr: ['Periyodik', 'Tablo'],
  uk: ['Таблиця', 'Менделєєва'],
  af: ['Periodieke', 'Tabel'],
  sq: ['Tabela', 'Periodike'],
  hy: ['Պարբերական', 'աղյուսակ'],
  az: ['Periodic', 'Table'],
  bn: ['পর্যায়', 'সারণী'],
  bs: ['Periodni', 'Sistem'],
  bg: ['Таблицата', 'на Менделеев'],
  ca: ['Taula', 'Periòdica'],
  kw: ['Periodic', 'Moos'],
  hr: ['Periodni', 'Sustav'],
  da: ['Det Periodiske', 'System'],
  nl: ['Periodiek', 'Systeem'],
  et: ['Perioodilisustabel', ''],
  fi: ['Jaksollinen', 'Järjestelmä'],
  gl: ['Táboa', 'Periódica'],
  ka: ['Periodic', 'Table'],
  el: ['Περιοδικός', 'Πίνακας'],
  gu: ['તત્વ', 'કોષ્ટક'],
  hu: ['Periódusos', 'Táblázat'],
  is: ['Lotukerfinu', ''],
  id: ['Tabel', 'Periodik'],
  ga: ['Tábla', 'Peiriadach'],
  kn: ['ಆವರ್ತಕ', 'ಕೋಷ್ಟಕ'],
  km: ['តារាងខួបនៃធាតុគីមី', ''],
  ky: ['Мезгилдик', 'Таблица'],
  lv: ['Periodiskā', 'Tabula'],
  lt: ['Periodinė', 'Elementų Lentelė'],
  mk: ['Периодична', 'Табела'],
  ms: ['Jadual', 'Berkala Unsur'],
  ml: ['ആവർത്തനപ്പട്ടിക', ''],
  ne: ['आवधिक', 'तालिका'],
  nb: ['Periodiske', 'Tabell'],
  ro: ['Tabelul', 'Periodic'],
  sr: ['Периодни', 'Систем'],
  sr_Latn: ['Periodni', 'Sistem'],
  si: ['ආවර්තිතා', 'වගුව'],
  sk: ['Periodická', 'Tabuľka'],
  sl: ['Periodična', 'Tabela'],
  sw: ['Periodic', 'Table'],
  sv: ['Periodiska', 'Systemet'],
  tg: ['Ҷадвали', 'даврӣ'],
  ta: ['தனிம', 'அட்டவணை'],
  te: ['ఆవర్తన', 'పట్టిక'],
  uz: ['Davriy', 'Jadval'],
  vi: ['Periodic', 'Table']
};

// 'pt_BR' -> 'pt-br' (имя папки в src/translate)
const toDir = lng => lng.toLowerCase().replace('_', '-');

const buildTranslation = (lng, table, string, array, calc) => ({
  periodic_table_1: titles[lng][0],
  periodic_table_2: titles[lng][1],
  table,
  string,
  array,
  calc
});

i18next.use(initReactI18next).init({
  resources: {
    en: {
      translation: buildTranslation('en', tableEN, stringEN, arrayEN, calcEN)
    }
  },
  lng: 'en',
  fallbackLng: 'en'
});

const loaded = new Set();

// Загружает только нужный язык (каждый язык — отдельный чанк).
// summary — описания элементов из Android (element_summary); у en тоже грузятся по требованию
export const loadLanguage = async lng => {
  if (loaded.has(lng)) {
    return;
  }
  const dir = toDir(lng);
  const summary = import(`./translate/summary/${dir}/summary.json`);
  if (lng === 'en') {
    i18next.addResourceBundle('en', 'translation', { summary: (await summary).default }, true, true);
  } else {
    const [table, string, array, calc] = await Promise.all([
      import(`./translate/table/${dir}/table.json`),
      import(`./translate/language/${dir}/string_${dir}.json`),
      import(`./translate/language/${dir}/array_${dir}.json`),
      import(`./translate/calc/${dir}/calculators.json`)
    ]);
    i18next.addResourceBundle(lng, 'translation', {
      ...buildTranslation(lng, table.default, string.default, array.default, calc.default),
      summary: (await summary).default
    });
  }
  loaded.add(lng);
};

export default i18next;
